import { lazy } from 'react';

import { LazyLoad } from '@/shared/ui';

export const PreviewRoute = LazyLoad(
  lazy(() => import('./preview').then((module) => ({ default: module.Preview }))),
);
